import React from 'react';

import NoticeCard from '../../NoticeCard/NoticeCard';
import InfoGeneral from '../InfoGeneral/InfoGeneral';
import BankAccounts from './BankAccounts/BankAccounts';
import { ReactComponent as ArrowDownLine } from '../../../assets/icons/ArrowDownLine.svg';
import InfoSalaryProcess from './InfoSalaryProcess/InfoSalaryProcess';
import Button from '../../Buttons/Button/Button';

import classes from './DetailsPayProcess.module.scss';

const DetailsPayProcess = ({ collaborator, isProcess }) => {
  return (
    <div>
      <span className='bold-20'>{isProcess ? 'Detalles de pago en proceso' : 'Detalles de pago realizado'}</span>
      {isProcess && (
        <NoticeCard
          className={classes.notice}
          text='El pago puede demorarse hasta un día hábil en efectuarse desde el momento en que se inició el proceso.'
        />
      )}
      <InfoGeneral collaborator={collaborator} />
      <InfoSalaryProcess collaborator={collaborator} isProcess={isProcess} />
      <BankAccounts accountsBanks={collaborator} />
      <span className={`medium-14 ${classes.transfer}`}>Transacción número {collaborator.payoutId}</span>
    </div>
  );
};

export default DetailsPayProcess;
